import { colors, spacing, Typography } from "@procore/core-react";
import type { ReactNode } from "react";

import EmptyIcon from "media/icons/empty.svg?react";

interface EmptyStateProps {
    title: string;
    message: string;
    showIcon?: boolean;
    illustration?: ReactNode;
    "data-testid"?: string;
}

export function EmptyState({
    title,
    message,
    showIcon = true,
    illustration,
    "data-testid": testid = "empty-state",
}: EmptyStateProps) {
    return (
        <div
            data-testid={testid}
            style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: spacing.lg,
                gap: spacing.md,
            }}
        >
            {showIcon &&
                (illustration ?? (
                    <EmptyIcon
                        style={{
                            width: 96,
                            height: 96,
                        }}
                    />
                ))}
            <Typography
                data-testid={`${testid}-title`}
                style={{
                    fontSize: "1.1em",
                    fontWeight: "600",
                    color: colors.gray15,
                    marginBottom: spacing.xs,
                }}
            >
                {title}
            </Typography>
            <Typography
                data-testid={`${testid}-message`}
                style={{
                    color: colors.gray45,
                    lineHeight: "1.5",
                    maxWidth: "300px",
                }}
            >
                {message}
            </Typography>
        </div>
    );
}
